// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const GROUP_LIST = "Seznam skupin";
export const GROUPS_CREATE_NEW_GROUP = "Zalo\u017e skupinu";
export const LIST_OF_FORUMS = "Seznam f\u00f3r";
export const SELECT_CATEGORY = "Vyber kategorii";
export const SEO_TITLE_GROUP_LIST = "Seznam skupin";
export const SEO_TITLE_SELECT_CATEGORY = "Vyber kategorii";
